
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import TagsListView from "./tags-list.html";
import TagsEditView from "./tags-edit.html";

angular.module('tags', [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('tags', {
                url: "/tags",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('tags.list', {
                url: "/list",
                controller: "tagsListCtrl",
                template: TagsListView,
                requiredPermission: ["FILES_READ"]
            })

            .state('tags.edit', {
                url: "/edit/:id",
                controller: "tagsEditCtrl",
                template: TagsEditView,
                resolve: {
                    entity_type: function () {
                        return null;
                    },
                    entity_id: function () {
                        return null;
                    }
                },

                requiredPermission: ["FILES_READ"]
            })

    }]);